export const LaborupGear = ({
  color,
  height = 24,
  stroke = "transparent",
  width = 24,
}: {
  color: string;
  height?: number;
  stroke?: string;
  width?: number;
}) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        height,
        stroke,
        width,
      }}
    >
      <path
        d="M10.2411 0L9.47322 3.28571C8.82442 3.47323 8.20515 3.73394 7.625 4.05357L4.75893 2.27679L2.26786 4.75893L4.04464 7.63393C3.7296 8.20761 3.48071 8.82357 3.29464 9.46429L0 10.2411V13.7589L3.28571 14.5268C3.47249 15.173 3.7357 15.7879 4.05357 16.3661L2.26786 19.2411L4.75893 21.7321L7.63393 19.9464C8.21207 20.2643 8.82702 20.5275 9.47322 20.7143L10.2411 24H13.7589L14.5268 20.7143C15.1756 20.5267 15.7948 20.2661 16.375 19.9464L19.2411 21.7321L21.7232 19.2411L19.9464 16.375C20.2661 15.7948 20.5268 15.1756 20.7143 14.5268L24 13.7589V10.2411L20.7143 9.47322C20.5268 8.82442 20.2661 8.20517 19.9464 7.625L21.7232 4.75893L19.2411 2.27679L16.3839 4.05357C15.8018 3.73214 15.1782 3.474 14.5268 3.28571L13.7589 0H10.2411ZM12 7.42857C14.5247 7.42857 16.5714 9.47527 16.5714 12C16.5714 14.5247 14.5247 16.5714 12 16.5714C9.47527 16.5714 7.42857 14.5247 7.42857 12C7.42857 9.47527 9.47527 7.42857 12 7.42857Z"
        fill={color}
      />
    </svg>
  );
};
